module.exports = __webpack_public_path__ + "img/merchantMgt.db13726b.svg";